import { defineStore } from "pinia";

import { RecruitmentDefaultModel } from "@core/models";
import {
  ACTION_DASHBOARD_CLOSE_RECRUITMENT_RECAP_MODAL,
  ACTION_DASHBOARD_SET_DRAWER_TITLE,
  ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL,
  GETTER_DASHBOARD_RECRUITMENT_RECAP_MODAL_OPENED,
  GETTER_DASHBOARD_RECRUITMENT_RECAP,
  GETTER_DASHBOARD_TITLE,
} from "@etab/stores/types";

export const useDashboardStore = defineStore("dashboard", {
  // convert to a function
  state: () => ({
    recruitmentRecapModalOpened: false,
    recap: new RecruitmentDefaultModel(),
    drawerTitle: "",
  }),
  getters: {
    [GETTER_DASHBOARD_RECRUITMENT_RECAP_MODAL_OPENED]: (state) => state.recruitmentRecapModalOpened,
    [GETTER_DASHBOARD_RECRUITMENT_RECAP]: (state) => state.recap,
    [GETTER_DASHBOARD_TITLE]: (state) => state.drawerTitle,
  },
  actions: {
    async [ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL]({ recap } = {}) {
      this.recruitmentRecapModalOpened = true;
      this.recap = recap;
    },
    async [ACTION_DASHBOARD_CLOSE_RECRUITMENT_RECAP_MODAL]() {
      this.recruitmentRecapModalOpened = false;
      this.recap = new RecruitmentDefaultModel();
    },
    async [ACTION_DASHBOARD_SET_DRAWER_TITLE](drawerTitle) {
      this.drawerTitle = drawerTitle;
    },
    // easily reset state using `$reset`
    clearDashboardStore() {
      this.$reset();
    },
  },
});
